import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/lib/components/Popover";
import FormRow from "./FormRow";
import { useVolume } from "./image-list-item-hooks";
import { CreativeProjectTimelineItem } from "@repo/api/creative-project";
import { IconVolume, IconVolumeOff } from "@tabler/icons-react";
import { Button } from "@/lib/components/Button/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/lib/components/Tooltip";
import SliderInputField from "@/lib/components/SliderInputField";
import { Slider } from "@/lib/components/Slider";

type Props = {
  timelineItem: CreativeProjectTimelineItem;
};

export default function VolumePopover({ timelineItem }: Props) {
  const { value, minValue, maxValue, handleChange, handleCommit } =
    useVolume(timelineItem);

  return (
    <Popover>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button size="iconXs" variant="outline">
              {value === 0 ? <IconVolumeOff /> : <IconVolume />}
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>
          <p>Volume</p>
        </TooltipContent>
      </Tooltip>

      <PopoverContent className="w-112.5 pt-4 pb-5" align="center" side="top">
        <FormRow label="Volume" classNameLabel="w-30" classNameContainer="h-8">
          <Slider
            value={value}
            onValueChange={handleChange}
            onValueCommit={handleCommit}
            min={minValue}
            max={maxValue}
            step={0.01}
          />
          <SliderInputField
            value={Math.round(value * 100)}
            onCommit={(newValue) =>
              handleCommit(Math.max(0, Math.min(1, newValue / 100)))
            }
            min={0}
            max={100}
            decimalPlaces={0}
            className="max-w-12 min-w-12"
            suffix="%"
          />
        </FormRow>
      </PopoverContent>
    </Popover>
  );
}
